import { enableProdMode, ErrorHandler, importProvidersFrom, provideAppInitializer, inject, provideZonelessChangeDetection, provideBrowserGlobalErrorListeners} from '@angular/core';
import { fluentButton, fluentCheckbox, fluentCombobox, fluentDivider, fluentMenu, fluentMenuItem, fluentOption, fluentProgressRing, fluentSelect, fluentSwitch, fluentTab, fluentTabPanel, fluentTabs, fluentTextField, fluentTooltip, provideFluentDesignSystem } from '@fluentui/web-components';
import { environment } from './environments/environment';
import { AppComponent } from './app/app.component';
import { AppRoutingModule } from './app/app-routing.module';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { AppService } from './app/service/app.service';
import { AlertService } from './app/service/alert.service';
import { WebViewInteropService } from './app/service/web-view-interop.service';
import { AcsService } from './app/service/acs.service';
import { AuthService } from './app/service/auth.service';
import { CustomHttpInterceptor } from './app/service/custom-http-interceptor';
import { provideHttpClient, withInterceptors, HTTP_INTERCEPTORS, withInterceptorsFromDi } from '@angular/common/http';
import { of } from 'rxjs';
import { AuthConfigService } from './app/service/auth-config.service';
import { provideAuth, StsConfigLoader,  StsConfigHttpLoader, authInterceptor, AbstractSecurityStorage, DefaultLocalStorageService } from 'angular-auth-oidc-client';

const authFactory = (configService: AuthConfigService) => {
  var configAzureAd$ = configService.getConfigAsync("AzureAd");
  var configAzure$ = configService.getConfigAsync("Acs");

  /*
  We have to get the configuration from the local storage here, because the library cannot get data via http with the http interceptor. The interceptor is not ready 
   */
  if (sessionStorage.getItem("CRMConf")) {
    const configConnector = JSON.parse(sessionStorage.getItem("CRMConf")!);
    //console.log("Loaded Connector config from sessionStorage", configConnector);
    const configConnector$ = of(configConnector);
    return new StsConfigHttpLoader([configAzureAd$, configAzure$, configConnector$]);
  }
  else {
    return new StsConfigHttpLoader([configAzureAd$, configAzure$]);
  }
};

if (environment.production) {
  enableProdMode();
}

provideFluentDesignSystem().register(
  fluentTab(),
  fluentTabs(),
  fluentTabPanel(),
  fluentButton(),
  fluentTextField(),
  fluentDivider(),
  fluentMenu(),
  fluentMenuItem(),
  fluentProgressRing(),
  fluentTooltip(),
  fluentCheckbox(),
  fluentCombobox(),
  fluentOption(),
  fluentSelect(),
  fluentSwitch(),
)

bootstrapApplication(AppComponent, {
  providers: [
    provideZonelessChangeDetection(),
    importProvidersFrom(BrowserModule, AppRoutingModule),
    provideBrowserGlobalErrorListeners(),
    provideAuth({
      loader: {
        provide: StsConfigLoader,
        useFactory: authFactory,
        deps: [AuthConfigService]
      }
    }),
    //withAppInitializerAuthCheck()),
    provideHttpClient(withInterceptors([authInterceptor()])),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: CustomHttpInterceptor,
      multi: true
    },
    {
      provide: AbstractSecurityStorage,
      useClass: DefaultLocalStorageService
    },
    AuthService,
    AcsService,
    WebViewInteropService,
    {
      provide: ErrorHandler,
      useExisting: AlertService //we have to use useExisting here because, we need to provide the CustomErrorHandler for the alert component. Otherwise we would have 2 different instances, so the EventEmitter will not work
    },
    AlertService,
    provideAppInitializer(()=>{
      const initService = inject(AppService);
      initService.Init();
    }),
    provideHttpClient(withInterceptorsFromDi())
  ]
})
  .catch(err => console.error(err));
